export const QUANTITY_PRESETS = [1, 2, 3, 5] as const;

export const EXPIRY_PRESETS = [
  { label: 'Tomorrow', days: 1 },
  { label: '3 days', days: 3 },
  { label: '1 week', days: 7 },
  { label: '2 weeks', days: 14 },
  { label: '1 month', days: 30 },
  { label: '3 months', days: 90 },
] as const;

export type ExpiryPreset = (typeof EXPIRY_PRESETS)[number];

/** Returns YYYY-MM-DD string using LOCAL date math (not UTC). */
export function calculateExpiryDate(daysFromToday: number): string {
  const date = new Date();
  date.setDate(date.getDate() + daysFromToday);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export interface ExpiryThresholdPreset {
  label: { message: string; context: string };
  days: number;
}

/**
 * Expiry threshold presets with translatable labels.
 * Labels are plain message descriptor objects — pass them to the translation helper
 * (e.g. `translatePresetLabel(i18n, preset.label)`) at render time.
 */
export const EXPIRY_THRESHOLD_PRESETS: ReadonlyArray<ExpiryThresholdPreset> = [
  { label: { message: '1 day', context: 'expiry_preset' }, days: 1 },
  { label: { message: '2 days', context: 'expiry_preset' }, days: 2 },
  { label: { message: '3 days', context: 'expiry_preset' }, days: 3 },
  { label: { message: '5 days', context: 'expiry_preset' }, days: 5 },
  { label: { message: '1 week', context: 'expiry_preset' }, days: 7 },
  { label: { message: '2 weeks', context: 'expiry_preset' }, days: 14 },
  { label: { message: '1 month', context: 'expiry_preset' }, days: 30 },
];
